import { queryOptions, useQuery } from '@tanstack/react-query';

import type { InvoiceTemplate } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { findDataInQueryCache } from '../utils';
import { invoiceTemplateSchema } from './schemas';

export const invoiceTemplateQueryOptions = (id: number) => {
  const cachedInvoiceTemplate = findDataInQueryCache<InvoiceTemplate>(
    [...QueryKeys.invoiceTemplates.index.root, 'metadata'],
    (invoiceTemplate) => invoiceTemplate.id === id,
  );

  return queryOptions({
    queryKey: QueryKeys.invoiceTemplates.show.id(id ?? 0),
    queryFn: async () => {
      const { data: invoiceTemplate } = await fetchJson(`/invoice-templates/${id}`, {
        schema: apiResourceSchema(invoiceTemplateSchema),
      });

      return invoiceTemplate;
    },
    staleTime: 60 * 1000,
    initialData: cachedInvoiceTemplate?.data,
    initialDataUpdatedAt: cachedInvoiceTemplate?.state.dataUpdatedAt,
  });
};

export const useInvoiceTemplate = (id: number) => {
  return useQuery(invoiceTemplateQueryOptions(id));
};
